export { default as EmojiEmbrassedIcon } from './emoji_embrassed.svg';
